import { type FC, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { ProviderCallPopUpDefault } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { type CallPopUpDefaultStore } from 'widgets/CallPopUp/store/callPopUpDefaultStore'
import { CallPopUpDefaultContent } from 'widgets/CallPopUp/ui/CallPopUpDefaultContent'

type ICallPopUpDefaultProps = {
  store: CallPopUpDefaultStore
}

export const CallPopUpDefault: FC<ICallPopUpDefaultProps> = observer(({ store }) => {
  return useMemo(
    () => (
      <ProviderCallPopUpDefault value={store}>
        <CallPopUpDefaultContent />
      </ProviderCallPopUpDefault>
    ),
    []
  )
})
